export enum FillRequestType {
  QuickFill,
  DetailFill,
}

export namespace FillRequestType {
  let elements = [FillRequestType.QuickFill, FillRequestType.DetailFill];
  let alias = "com.bcdfx.model.FillRequestType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
